import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useMeilisearch } from 'src/hooks/meilisearch/use-meilisearch';
import { useUserStore } from 'src/store/user-store';
import { fetchSpaceGroups } from '../lib/space-groups';
import { spaceGroupsKeys } from '../query-keys/space-groups';

export const useSpaceGroupsByTokens = (tokens: string[]) => {
  const { directoryToken } = useUserStore();

  const searchState: SearchState = {
    filter: [tokens.map(token => `token = ${token}`) ?? []],
    q: '',
    sort: [],
  };

  const query = useMeilisearch({
    fetch: fetchSpaceGroups,
    queryKey: spaceGroupsKeys.list(
      directoryToken!,
      tokens.length ?? 0,
      0,
      searchState,
    ),
    page: 1,
    perPage: tokens.length ?? 0,
    searchState,
    enabled: tokens.length > 0,
  });

  return query;
};
